module.exports = __webpack_public_path__ + "static/media/icon1.2747076b.svg";